import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useTerms } from "../contexts/TermsContext";
import { wwwUrl } from "../config/environment";

const TermsConsentModal = () => {
    const { needsAcceptance, dismissed, accept, dismiss, acceptedVersion } = useTerms();
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    // First-time acceptance is a hard gate — no dismiss option.
    // Version bumps (user previously accepted an older version) stay soft.
    const isFirstTime = !acceptedVersion;
    const show = needsAcceptance && (isFirstTime || !dismissed);

    const handleAccept = async () => {
        setSubmitting(true);
        setError(null);
        try {
            await accept();
        } catch (e) {
            setError(e.message || "Could not record acceptance. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={isFirstTime ? () => {} : dismiss}
            backdrop="static"
            keyboard={!isFirstTime}
            centered
        >
            <Modal.Header closeButton={!isFirstTime}>
                <Modal.Title>
                    {isFirstTime ? "Before you continue" : "Updates to our terms"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isFirstTime ? (
                    <p>
                        Please review and accept our{" "}
                        <a href={wwwUrl("/terms")} target="_blank" rel="noopener noreferrer">Terms of Service</a>
                        {" "}and{" "}
                        <a href={wwwUrl("/privacy")} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                        {" "}to use Poker Ledger.
                    </p>
                ) : (
                    <>
                        <p>
                            We need you to review and accept our{" "}
                            <a href={wwwUrl("/terms")} target="_blank" rel="noopener noreferrer">Terms of Service</a>
                            {" "}and{" "}
                            <a href={wwwUrl("/privacy")} target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                        </p>
                        <p className="text-muted small mb-0">
                            You can keep using Poker Ledger for now, but we'll keep reminding you until you've accepted.
                        </p>
                    </>
                )}
                {error && <div className="text-danger mt-3">{error}</div>}
            </Modal.Body>
            <Modal.Footer>
                {!isFirstTime && (
                    <Button variant="outline-secondary" onClick={dismiss} disabled={submitting}>
                        Not now
                    </Button>
                )}
                <Button variant="primary" onClick={handleAccept} disabled={submitting}>
                    {submitting ? "Saving..." : "I agree"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TermsConsentModal;
